// @flow

export default function homeUrl() {
  return '/'
}
